import { render } from "./PartnerComp.vue?vue&type=template&id=044bd3a1"
import script from "./PartnerComp.vue?vue&type=script&lang=js"
export * from "./PartnerComp.vue?vue&type=script&lang=js"

import "./PartnerComp.vue?vue&type=style&index=0&id=044bd3a1&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\compro.rimba.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__